const KEY_A = 'A';
const KEY_C = 'C';
const KEY_V = 'V';
const KEY_D = 'D';
const KEY_PAGE_UP = 'PageUp';
const KEY_PAGE_DOWN = 'PageDown';
const KEY_TAB = 'Tab';
const KEY_LEFT = 'ArrowLeft';
const KEY_UP = 'ArrowUp';
const KEY_RIGHT = 'ArrowRight';
const KEY_DOWN = 'ArrowDown';
const KEY_F2 = 'F2';
const KEY_BACKSPACE = 'Backspace';
const KEY_ESCAPE = 'Escape';
const KEY_SPACE = ' ';
const KEY_DELETE = 'Delete';
const KEY_PAGE_HOME = 'Home';
const KEY_PAGE_END = 'End';
function suppressNavigation(params) {
  var event = params.event;
  var key = event.key;
  var keysToSuppress = [
    KEY_PAGE_UP,
    KEY_PAGE_DOWN,
    KEY_TAB,
    KEY_F2,
    KEY_ESCAPE,
  ];
  var editingKeys = [
    KEY_LEFT,
    KEY_RIGHT,
    KEY_UP,
    KEY_DOWN,
    KEY_BACKSPACE,
    KEY_DELETE,
    KEY_SPACE,
    KEY_PAGE_HOME,
    KEY_PAGE_END,
  ];
  if (event.ctrlKey || event.metaKey) {
    keysToSuppress.push(KEY_A);
    keysToSuppress.push(KEY_V);
    keysToSuppress.push(KEY_C);
    keysToSuppress.push(KEY_D);
  }
  if (!params.editing) {
    keysToSuppress = keysToSuppress.concat(editingKeys);
  }
  if (params.column.colId && (key === KEY_UP || key === KEY_DOWN)) {
    return false;
  }
  var suppress = keysToSuppress.some(function (suppressedKey) {
    return suppressedKey === key || key.toUpperCase() === suppressedKey;
  });
  return suppress;
}

export default suppressNavigation;

export const navigateToNextCell = (params) => {
  var previousCell = params.previousCellPosition;
  var suggestedNextCell = params.nextCellPosition;
  if (suggestedNextCell?.rowIndex < 0) return null;
  switch (params.key) {
    case KEY_DOWN:
      var nextRowIndex = previousCell.rowIndex + 1;
      if (nextRowIndex < 0) {
        return null;
      } else {
        return {
          rowIndex: nextRowIndex,
          column: previousCell.column,
          floating: previousCell.floating,
        };
      }
    case KEY_UP:
      var nextRowIndex = previousCell.rowIndex - 1;
      var renderedRowCount = params.api.getModel().getRowCount();
      if (nextRowIndex >= renderedRowCount) {
        return null;
      } else {
        return {
          rowIndex: nextRowIndex,
          column: previousCell.column,
          floating: previousCell.floating,
        };
      }
    default:
      throw new Error(
        'this will never happen, navigation is always on of the 4 keys above'
      );
  }
};

export const onCellFocused = (p) => {
  const dom = p?.api.gridOptionsWrapper.eGridDiv.children[0];
  let row;
  if (p?.rowPinned === 'bottom') {
    row = dom?.querySelector(
      `.ag-floating-bottom-container div[row-index="b-${p?.rowIndex}"]`
    );
  } else {
    row = dom?.querySelector(
      `.ag-center-cols-container div[row-index="${p?.rowIndex}"]`
    );
  }

  const coll = row?.querySelector(`div[col-id="${p?.column.colId}"]`);
  if (!coll) return;

  const activeElement = document.activeElement;
  if (activeElement) {
    const role = activeElement.getAttribute && activeElement.getAttribute('role');
    if (
      role === 'menu' ||
      role === 'menuitem' ||
      role === 'listbox' ||
      role === 'option'
    ) {
      return;
    }

    let el = activeElement;
    while (el) {
      if (el.classList) {
        if (
          el.classList.contains('MuiMenu-paper') ||
          el.classList.contains('MuiMenu-list') ||
          el.classList.contains('MuiPopover-root') ||
          el.classList.contains('export_dropdown')
        ) {
          return;
        }
      }
      el = el.parentElement;
    }

    if (coll.contains(activeElement) && activeElement !== coll) {
      return;
    }
  }

  const focusable_ele = coll.querySelector(
    'input, select, textarea, a, button, [tabindex]:not([tabindex="-1"])'
  );

  if (focusable_ele) {
    focusable_ele.focus();
  }
};

export const onCellFocusedSkipDisabled = (p) => {
  const dom = p?.api.gridOptionsWrapper.eGridDiv.children[0];
  let row;
  if (p?.rowPinned === 'bottom') {
    row = dom?.querySelector(
      `.ag-floating-bottom-container div[row-index="b-${p?.rowIndex}"]`
    );
  } else {
    row = dom?.querySelector(
      `.ag-center-cols-container div[row-index="${p?.rowIndex}"]`
    );
  }

  const coll = row?.querySelector(`div[col-id="${p?.column.colId}"]`);
  if (!coll) return;

  const activeElement = document.activeElement;
  if (activeElement) {
    const role = activeElement.getAttribute && activeElement.getAttribute('role');
    if (
      role === 'menu' ||
      role === 'menuitem' ||
      role === 'listbox' ||
      role === 'option'
    ) {
      return;
    }

    let el = activeElement;
    while (el) {
      if (el.classList) {
        if (
          el.classList.contains('MuiMenu-paper') ||
          el.classList.contains('MuiMenu-list') ||
          el.classList.contains('MuiPopover-root') ||
          el.classList.contains('export_dropdown')
        ) {
          return;
        }
      }
      el = el.parentElement;
    }

    if (coll.contains(activeElement) && activeElement !== coll) {
      return;
    }
  }

  const focusableCandidates = Array.from(
    coll.querySelectorAll(
      'input, select, textarea, a, button, [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => {
    const isDisabled =
      el.disabled === true || el.getAttribute?.('aria-disabled') === 'true';
    return !isDisabled;
  });

  const focusable_ele = focusableCandidates[0];

  if (focusable_ele) {
    focusable_ele.focus();
  }
};

export const tabToNextCell = (params) => {
  const previousCell = params?.previousCellPosition;
  const lastRowIndex = previousCell?.rowIndex;
  const nextRowIndex = params?.backwards ? lastRowIndex - 1 : lastRowIndex + 1;
  const renderedRowCount = params?.api.getModel().getRowCount();
  let result;

  // Existing behavior: If the next row is before the first row, allow moving outside
  if (nextRowIndex < 0 && previousCell?.rowIndex > -1) {
    result = { rowIndex: -1 }; // Moving out of the grid (to a previous focusable element)
  } 
  // Existing behavior: If the next row is past the last row, allow moving out of the grid
  else if (nextRowIndex >= renderedRowCount) {
    result = null; // Returning null lets the browser handle focus outside the grid
  } else {
    // Existing behavior: Normal row/column navigation within the grid
    result = {
      rowIndex: nextRowIndex,
      column: previousCell?.column,
      floating: previousCell?.floating,
    };
  }

  return result;
};

  export const handleTabToNextCell = (params) => {
    const { nextCellPosition, previousCellPosition } = params;
    if (!params.backwards && previousCellPosition) {
      const allColumns = params.columnApi.getAllDisplayedColumns();
      const lastColumn = allColumns[allColumns.length - 1];
      const rowCount = params.api.getModel().getRowCount();
      const lastRowIndex = rowCount - 1;

      if (
        previousCellPosition.rowIndex === lastRowIndex &&
        previousCellPosition.column === lastColumn
      ) {
        return null;
      }
    }
    return nextCellPosition;
  };